exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alarms .btn-device-link{margin-right:5px;max-width:200px;text-overflow:ellipsis;overflow:hidden}.alarms .alarms-header{display:flex;align-items:center}.alarms .alarms-header .alarms-title{flex-grow:1}", ""]);

// exports
